import WineCard from '@/components/wine/WineCard';
import type { CellarItem } from '@/hooks/useCellar';

interface CellarGridProps {
  items: CellarItem[];
  emptyMessage?: string;
}

export default function CellarGrid({ items, emptyMessage = 'No wines here yet.' }: CellarGridProps) {
  if (items.length === 0) {
    return <p className="cellar-empty">{emptyMessage}</p>;
  }

  return (
    <div className="cellar-grid">
      {items.map((item) => (
        <WineCard
          key={item.wineId}
          wine={item.wine}
          quantity={item.quantity}
        />
      ))}
    </div>
  );
}
